export default __webpack_public_path__ + "static/media/january.53939448.jpg";